import {Component, HostListener, OnInit} from '@angular/core';
import {ScheduleService} from '../../../services/schedule.service';

import {environment} from '../../../../environments/environment';
import {PlayerService} from '../../core/services/player/player.service';
import { ImagePipe } from '../../core/pipes/image.pipe';
import {Show} from '../../../services/schedule.model';
import {Show as ArchiveShow} from '../../../services/archive.model';

declare var $: any;
declare var navigator: any;

@Component({
  selector: 'psr-livestream-player',
  templateUrl: './livestream-player.component.html',
  styleUrls: ['./livestream-player.component.scss']
})
export class LivestreamPlayerComponent implements OnInit {
  public volumeMultiplier = 100;
  private order = 'mp3,oga';

  private playerEnabled = !(window.location.hostname === environment.iOSAppDomain);

  private imagePipe = new ImagePipe();

  public wasPaused = false;
  public playing = false;
  public muted = false;
  public volume = 90;
  private oldVolume: number = this.volume;

  public archivePlaying = false;

  public currentShow: string;

  private defaultArtwork = [
    {src: '/assets/favicons/android-icon-48x48.png', sizes: '48x48', type: 'image/png'},
    {src: '/assets/favicons/android-icon-96x96.png', sizes: '96x96', type: 'image/png'},
    {src: '/assets/favicons/android-icon-144x144.png', sizes: '144x144', type: 'image/png'},
    {src: '/assets/favicons/android-icon-192x192.png', sizes: '192x192', type: 'image/png'}
  ];


  constructor(private ss: ScheduleService, private playerService: PlayerService) {
    this.playerService.isPlaying.subscribe((isPlaying: boolean) => {
      this.archivePlaying = isPlaying;

      if (this.archivePlaying) {
        this.pause();
        this.setMediaSession(null, this.playerService.currentlyPlaying.getValue());
      }
    });
  }

  ngOnInit(): void {
    if (this.playerEnabled) {
      this.initPlayer();
      if ('mediaSession' in navigator) {
        this.initMediaSession();
      }
    }
  }

  setMediaSession(show?: Show, archiveShow?: ArchiveShow): void {
    navigator.mediaSession.setActionHandler('play', () => {
      if (archiveShow) {
        this.playerService.audio.play();
      }
      else {
        this.play();
      }
    });
    navigator.mediaSession.setActionHandler('pause', () => {
      if (archiveShow) {
        this.playerService.pause();
      } else {
          this.pause();
      }
    });
    let title = '~~~';
    let artwork = this.defaultArtwork;
    if (show) {
        title = show.name;

        if (show.image_path) {
            artwork = [{
              src: show.image_path,
              sizes: '640x640',
              type: 'image/png'
            }];
        }
    }
    else if (archiveShow) {
        title = archiveShow.title;

        artwork = [{
          src: this.imagePipe.transform(archiveShow.artwork, 'tiny'),
          sizes: '640x640',
          type: 'image/png'
        }];
    }

    // @ts-ignore: MediaMetadata not supported by TypeScript
    navigator.mediaSession.metadata = new MediaMetadata({
      artist: 'Palanga Street Radio',
      title: title,
      artwork: artwork
    });
  }

  initMediaSession(): void {
    this.setMediaSession();

    // TODO: change this
    this.ss.scheduleData.subscribe(data => {
      if (data.current !== undefined && !this.archivePlaying) {
        this.currentShow = data.current.name;
        this.setMediaSession(data.current);
      }
    });
  }

  setMedia(): void {
    $('#player').jPlayer('setMedia', {
      title: 'Palanga Street Radio',
      oga: environment.streamOgaUrl,
      mp3: environment.streamMp3Url
    });
  }

  initPlayer(): void {
    $('#player').jPlayer({
      ready: () => {
        this.setMedia();
      },
      play: event => {
        // @TODO: Recreate play event
        // maybe_switch_logo();
        // onplay_ga();
        this.playing = true;
      },
      pause: event => {
        // @TODO: Recreate pause event
        // switch_back_to_regular_logo();
        this.playing = false;
        this.wasPaused = true;
      },
      cssSelectorAncestor: '#player',
      swfPath: 'assets/js/jplayer/jquery.jplayer.swf',
      solution: 'html,flash',
      supplied: this.order,
      useStateClassSkin: true,
      autoBlur: false,
      volume: this.volume / this.volumeMultiplier,
      smoothPlayBar: true,
      preload: 'auto',
      keyEnabled: false,
      remainingDuration: false,
      toggleDuration: false
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.code === 'Space') {
      this.togglePlay();
    } else if (event.code === 'KeyM') {
      this.toggleMute();
    }
  }

  togglePlay(): void {
    if (this.playerEnabled) {
      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    }
  }

  play(): void {
    if (this.archivePlaying) {
      this.playerService.pause();
    }

    if (this.wasPaused) {
      $('#player').jPlayer('clearMedia');
      this.setMedia();
    }
    $('#player').jPlayer('play');
  }

  pause(): void {
    $('#player').jPlayer('pause');
    // if we are on Android, we need to keep the
    // media to be able to resume, so we don't do anything
    if ('mediaSession' in navigator) {
    } else {
      $('#player').jPlayer('clearMedia');
    }
  }

  setVolume(): void {
    // @TODO: fix volume controls
    console.log(this.volume);
    if (this.volume < 5) {
      this.volume = 0;
    }
    $('#player').jPlayer('volume', this.volume / this.volumeMultiplier);
  }

  toggleMute(): void {
    if (this.muted) {
      this.unmuteVolume();
    } else {
      this.muteVolume();
    }
  }

  muteVolume(): void {
    this.oldVolume = this.volume;
    this.volume = 0;
    this.setVolume();
    this.muted = true;
  }

  unmuteVolume(): void {
    this.volume = this.oldVolume;
    this.setVolume();
    this.muted = false;
  }
}
